/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Usermanagement_Help_Clickhere2Inputs */

const en_usermanagement_help_clickhere2 = /** @type {(inputs: Usermanagement_Help_Clickhere2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`click here`)
};

/**
* | output |
* | --- |
* | "click here" |
*
* @param {Usermanagement_Help_Clickhere2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const usermanagement_help_clickhere2 = /** @type {((inputs?: Usermanagement_Help_Clickhere2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Usermanagement_Help_Clickhere2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_usermanagement_help_clickhere2(inputs)
});
export { usermanagement_help_clickhere2 as "userManagement_help_clickHere" }